// extracted by mini-css-extract-plugin
export default {"skill":"styles_skill__fW8m8","skillName":"styles_skillName__yRlWG"};